module.exports = __webpack_public_path__ + "img/user09.92a34973.jpg";